//on document load
document.addEventListener('DOMContentLoaded', () => {

    const atcLinks = document.querySelectorAll('.js-open-product-link');
    Array.from(atcLinks).forEach(item => item.addEventListener('click', (e) => {

        const card = e.target.closest('.grid__item');
        // get the product added to the cart
        const selectedSwatchIndex = card.querySelector('.js-color-swatch.active-swatch').getAttribute('data-index')
        const selectedSize = card.querySelector('.size-btn.active-size');
        const selectedSizeUrl = selectedSize.getAttribute('data-product-url');
        const variants = selectedSize.getAttribute('sub_variants_ids').split(',');
        const selectedSwatch = variants[selectedSwatchIndex];

        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);

        params.set('variant', selectedSwatch);

        var newurl = url.origin + selectedSizeUrl + '?' + params.toString();

        // redirect to that product url
        window.location.href = newurl;

    }));
});